<template>
  <div class="aside">
    <el-menu
      class="el-menu-vertical"
      :default-active="$route.path"
      @select="selectMenu"
      :collapse="$store.getters.isCollapse"
      text-color="#000000"
      active-text-color="#4d83b9"
      :router="$store.getters.uniquerouter"
      :unique-opened="$store.getters.uniquerouter"
      :collapse-transition="true"
    >
      <template
        v-for="(item, index) in $store.getters.routers"
        v-if="!item.hidden"
      >
        <el-submenu
          v-if="!item.alone && item.children.length > 0"
          :index="index + ''"
        >
          <template slot="title">
            <!-- <i :class="item.iconCls ? item.iconCls : 'fa, fa - server'"></i> -->
            <span slot="title">{{ item.name }}</span>
          </template>

          <menu-tree :menuData="item.children"></menu-tree>
        </el-submenu>
        <el-menu-item :index="item.path" v-else>
          <!-- <i :class="item.iconCls ? item.iconCls : 'fa, fa - file'"></i> -->
          <span slot="title">{{ item.name }}</span>
        </el-menu-item>
      </template>
    </el-menu>
  </div>
</template>

<script>
import menuTree from "./menuTree";

export default {
  name: "asideNav",
  data() {
    return {};
  },
  components: {
    menuTree,
  },
  watch: {
    // 监听浏览器直接输入路由，将此路由添加到tabNavBox
    "$route.path": function (val) {
      this.selectMenu(val);
    },
  },
  methods: {
    selectMenu(key) {
      let router = this.$store.getters.routers;
      let name = "";
      let navTitle = function (path, routerARR) {
        for (let i = 0; i < routerARR.length; i++) {
          if (routerARR[i].children.length > 0 || routerARR[i].path === path) {
            if (
              routerARR[i].path === path &&
              routerARR[i].children.length < 1
            ) {
              name = routerARR[i].name;
              break;
            }
            navTitle(path, routerARR[i].children);
          }
        }
        return name;
      };
      this.$store.dispatch("addTab", {
        title: navTitle(key, router),
        path: key,
      });
    },
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
  },
};
</script>

<style lang="scss" scoped>
.aside {
  width: 100%;
  height: 100%;
  overflow: auto;
  overflow-y: overlay;
}
::-webkit-scrollbar {
  display: none;
}

/deep/ .is-active {
  background-color: #d8eaff;
  .el-submenu__title {
    border-right: #356fa9 2px solid;
  }
}
/deep/ .el-menu-item.is-active {
  border-right: #356fa9 2px solid;
}

.el-menu-vertical:not(.el-menu--collapse) {
  width: 200px;
  min-height: 400px;
}
</style>



// WEBPACK FOOTER //
// src/system/index/layout/aside/aside.vue